// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cates-box{display:flex;align-items:center}.cates-box .el-cascader{width:250px}", ""]);
// Exports
module.exports = exports;
